declare let Ya: {
  Metrika2: (data: Record<string, any>) => void
}

function loadScript() {
  return new Promise((resolve, reject) => {
    const head = document.head || document.getElementsByTagName('head')[0]
    const script = document.createElement('script')
    let loaded = false
    script.async = true
    script.charset = 'utf-8'
    script.src = 'https://mc.yandex.ru/metrika/tag.js'

    // TODO: rework to array of event style init, hits etc
    Object.defineProperties(window, {
      __Ya: {
        value: undefined,
        writable: true,
      },
      Ya: {
        get: function () {
          return this.__Ya
        },
        set: function (value: any) {
          this.__Ya = value
          if (loaded) {
            return
          }
          setTimeout(() => {
            loaded = true
            if (typeof this.__Ya.Metrika2 !== 'function') {
              useLogError(
                new Error('Metrika2 constructor is not found in Ya object')
              )
              return
            }

            console.log('analytics: got Ya in window, resolve')
            resolve({ success: true })
          })
        },
      },
    })
    script.onerror = (error) => reject(error)
    try {
      head.appendChild(script)
    } catch (error: any) {
      console.log('failed to append ym', error)
    }
  })
}

function debug(message: string, args?: any) {
  console.log(`[Metrika] ${message}`, args)
}

export async function createMetrika(tag: string, isDebug = false) {
  await loadScript()

  if (!isDebug) {
    const yaMetrika = new (Ya.Metrika2 as any)({
      id: tag,
      accurateTrackBounce: true,
      clickmap: true,
      defer: false,
      ecommerce: false,
      params: [],
      userParams: {},
      trackHash: false,
      trackLinks: true,
      type: 0,
      webvisor: false,
      triggerEvent: false,
    })

    // @ts-ignore next-line
    window[`yaCounter${tag}`] = yaMetrika

    console.log('analytics: yandex metrika tag successfully inited')

    return yaMetrika
  } else {
    return {
      addFileExtension(...args: any[]) {
        debug('addFileExtension:', args)
      },
      extLink(...args: any[]) {
        debug('extLink:', args)
      },
      file(...args: any[]) {
        debug('file:', args)
      },
      getClientID(...args: any[]) {
        debug('getClientID:', args)
      },
      hit(...args: any[]) {
        debug('hit:', args)
      },
      notBounce(...args: any[]) {
        debug('notBounce:', args)
      },
      params(...args: any[]) {
        debug('params:', args)
      },
      reachGoal(...args: any[]) {
        debug('reachGoal:', args)
      },
      replacePhones(...args: any[]) {
        debug('replacePhones:', args)
      },
      setUserID(...args: any[]) {
        debug('setUserID:', args)
      },
      userParams(...args: any[]) {
        debug('userParams:', args)
      },
    }
  }
}
